<script>
import axios from "axios";

import helper from "./../mixins/helper";
import npcity from "./../../../general/inc/NPcity";
import npstreet from "./../../../general/inc/NPstreet";
import npnumber from "./../../../general/inc/NPnumber";
import phoneNumberInput from "./../inc/phoneNumberInput";

export default {
    mixins: [
        helper
    ],
    components: {
        npcity,
        npstreet,
        npnumber,
        'phone-number-input': phoneNumberInput
    },
    props: {
        user:{
            required: true
        },
        additional:{
            required: false
        },
    },
    data() {
        return {
            error: null,
            client_data: {
                fname: null,
                lname: null,
                mname: null,
                email: null,
                phone: null,
                password: null,
                password_confirmation: null
            },
            client_additional: {
                city: null,
                street: null,
                house: null,
                entrance: null,
                apartment: null,
                np_number: null,
                pickup_shop: null,
                data: {
                    city_json: null,
                    street_json: null,
                    np_number_json: null
                }
            },
            errors: {
                phone: null
            },
            allowRequest: true
        }
    },
    created() {
        console.log('Client cabinet');
    },
    beforeMount() {
        this.client_data = this.user;
        if (this.additional) {
            this.client_additional = this.additional;
        } 
    },
    mounted() {
        
    },
    computed: {
        has_error: function() {
            if (Object.values(this.errors).includes(true)) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        phoneError(error) {
            this.errors.phone = error;
        },
        updateCitydata(data) {
            this.client_additional.city = data.Present;
            this.client_additional.data.city_json = data;
        },
        updateStreetdata(data) {
            this.client_additional.street = data.Present;
            this.client_additional.data.street_json = data;
        },
        updateNPNumberdata(data) {
            this.client_additional.np_number = data.Description;
            this.client_additional.data.np_number_json = data;
        },
        update(e) {
            e.preventDefault();
            if (this.allowRequest && !this.has_error) {
                this.allowRequest = false;
                axios({
                    method: "put",
                    url: window.globalVariables.locale + "/user-and-additional-update",
                    data: {
                        user_data: this.client_data,
                        user_additional: this.client_additional
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.allowRequest = true;
                    location.reload();
                })
                .catch(error => {
                    this.allowRequest = true;
                    console.log(error);
                });
            }
        }
    }
}
</script>